import angular from 'angular';
import display from './builder/display.html';
import checkboxDirective from './checkbox.directive';

angular.module('app')
	.directive('kformCheckbox', checkboxDirective)
	.run(/* @ngInject */ (
		/** @type {import('angular').ITemplateCacheService} */ $templateCache,
	) => {
		$templateCache.put('kform/components/checkbox/display.html', display);
	});
